import React, { useEffect } from 'react';

const SecurityEnhancer: React.FC = () => {
  useEffect(() => {
    // Remove console.log in production
    if (process.env.NODE_ENV === 'production') {
      console.log = () => {};
      console.warn = () => {};
      console.error = () => {};
    }

    // Add security headers via meta tags (excluding X-Frame-Options which should be HTTP headers)
    const addSecurityHeaders = () => {
      const securityMeta = [
        { name: 'X-Content-Type-Options', content: 'nosniff' },
        { name: 'X-XSS-Protection', content: '1; mode=block' },
        { name: 'Referrer-Policy', content: 'strict-origin-when-cross-origin' },
        { name: 'Permissions-Policy', content: 'camera=(), microphone=(), geolocation=()' }
      ];

      securityMeta.forEach(meta => {
        if (!document.querySelector(`meta[http-equiv="${meta.name}"]`)) {
          const metaTag = document.createElement('meta');
          metaTag.setAttribute('http-equiv', meta.name);
          metaTag.setAttribute('content', meta.content);
          document.head.appendChild(metaTag);
        }
      });
    };

    // Add HSTS header
    const addHSTS = () => {
      if (!document.querySelector('meta[http-equiv="Strict-Transport-Security"]')) {
        const hstsMeta = document.createElement('meta');
        hstsMeta.setAttribute('http-equiv', 'Strict-Transport-Security');
        hstsMeta.setAttribute('content', 'max-age=31536000; includeSubDomains');
        document.head.appendChild(hstsMeta);
      }
    };

    // Add Content Security Policy
    const addCSP = () => {
      if (!document.querySelector('meta[http-equiv="Content-Security-Policy"]')) {
        const cspMeta = document.createElement('meta');
        cspMeta.setAttribute('http-equiv', 'Content-Security-Policy');
        cspMeta.setAttribute('content', 
          "default-src 'self'; " +
          "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://www.googletagmanager.com https://www.google-analytics.com https://pagead2.googlesyndication.com; " +
          "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; " +
          "font-src 'self' https://fonts.gstatic.com; " +
          "img-src 'self' data: https:; " +
          "connect-src 'self' https://www.google-analytics.com https://motivamatchbackend-production.up.railway.app https://api.motivamatch.com; " +
          "frame-src 'self' https://pagead2.googlesyndication.com;"
        );
        document.head.appendChild(cspMeta);
      }
    };

    // Add COOP (Cross-Origin-Opener-Policy)
    const addCOOP = () => {
      if (!document.querySelector('meta[http-equiv="Cross-Origin-Opener-Policy"]')) {
        const coopMeta = document.createElement('meta');
        coopMeta.setAttribute('http-equiv', 'Cross-Origin-Opener-Policy');
        coopMeta.setAttribute('content', 'same-origin');
        document.head.appendChild(coopMeta);
      }
    };

    // Add COEP (Cross-Origin-Embedder-Policy)
    const addCOEP = () => {
      if (!document.querySelector('meta[http-equiv="Cross-Origin-Embedder-Policy"]')) {
        const coepMeta = document.createElement('meta');
        coepMeta.setAttribute('http-equiv', 'Cross-Origin-Embedder-Policy');
        coepMeta.setAttribute('content', 'require-corp');
        document.head.appendChild(coepMeta);
      }
    };

    // Add Trusted Types for DOM XSS protection
    const addTrustedTypes = () => {
      if (!document.querySelector('meta[http-equiv="Trusted-Types"]')) {
        const trustedTypesMeta = document.createElement('meta');
        trustedTypesMeta.setAttribute('http-equiv', 'Trusted-Types');
        trustedTypesMeta.setAttribute('content', "'none'");
        document.head.appendChild(trustedTypesMeta);
      }
    };

    // Remove deprecated APIs
    const removeDeprecatedAPIs = () => {
      // Remove any usage of deprecated APIs
      if (typeof window !== 'undefined') {
        // Remove deprecated event handlers
        const deprecatedEvents = ['onmousewheel', 'onmouseover'];
        deprecatedEvents.forEach(event => {
          document.removeEventListener(event, () => {});
        });
      }
    };

    // Add source maps for debugging
    const addSourceMaps = () => {
      if (process.env.NODE_ENV === 'development') {
        const sourceMapMeta = document.createElement('meta');
        sourceMapMeta.setAttribute('name', 'source-map');
        sourceMapMeta.setAttribute('content', 'true');
        document.head.appendChild(sourceMapMeta);
      }
    };

    // Initialize all security enhancements
    const initializeSecurity = () => {
      addSecurityHeaders();
      addHSTS();
      addCSP();
      addCOOP();
      addCOEP();
      addTrustedTypes();
      removeDeprecatedAPIs();
      addSourceMaps();
    };

    // Run immediately
    initializeSecurity();

    // Add error handling for security
    window.addEventListener('error', (event) => {
      console.error('Security error:', event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason);
    });

  }, []);

  return null;
};

export default SecurityEnhancer;
